import * as Sentry from "@sentry/react"
import type { AnyRouter } from "@tanstack/react-router"

export function initSentry(router: AnyRouter) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    enabled: import.meta.env.VITE_NODE_ENV === "production",
    environment: import.meta.env.VITE_NODE_ENV ?? "development",
    integrations: [
      Sentry.tanstackRouterBrowserTracingIntegration(router),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [/^\/v1/, /^https:\/\/api\.yomimono\.ai/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}

export { Sentry }
